import { c as _c } from "react/compiler-runtime";
import { useRef, useState, useCallback, useEffect } from "react";
import Link from "next/link";
import { ChevronLeft, ChevronRight, MapPin, Calendar } from "lucide-react";
import { archivalCarouselEvents } from "@/data/archivalEventsData";
import EventCardMedia from "@/components/events/EventCardMedia";
const CARD_WIDTH = 340;
const GAP = 24;
const PastEvents = () => {
  const $ = _c(19);
  const trackRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const el = trackRef.current;
      if (!el) {
        return;
      }
      setCanScrollLeft(el.scrollLeft > 8);
      setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 8);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const updateScrollState = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = direction => {
      const el_0 = trackRef.current;
      if (!el_0) {
        return;
      }
      el_0.scrollBy({
        left: direction * (CARD_WIDTH + GAP),
        behavior: "smooth"
      });
      setTimeout(updateScrollState, 400);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const scrollByCards = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      updateScrollState();
      window.addEventListener("resize", updateScrollState);
      return () => window.removeEventListener("resize", updateScrollState);
    };
    t3 = [updateScrollState];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4"><div className="w-8 h-px bg-[#DF6D2A]" /><span className="font-body text-[10.5px] tracking-[0.25em] uppercase text-[#DF6D2A]">Previous Gatherings</span></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 mb-8 sm:mb-12"><div className="flex flex-col md:flex-row md:items-end justify-between gap-5 sm:gap-8"><div>{t4}<h2 className="font-display text-[32px] sm:text-[40px] md:text-[44px] lg:text-[56px] text-[#0F1C2E] leading-none">The Archival <em className="text-[#C9A84C] italic">Retrospective</em></h2></div><p className="font-body text-[13px] sm:text-[14px] text-[#4C596B] max-w-[400px] leading-[1.7] sm:leading-[1.8]">Milestones, summits, and cultural gatherings from across the Girmitiya diaspora, documented by the Global Girmitiya Council.</p></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="max-w-[1400px] mx-auto"><div ref={trackRef} onScroll={updateScrollState} className="flex gap-5 sm:gap-6 overflow-x-auto overscroll-x-contain snap-x snap-mandatory scroll-smooth pl-4 sm:pl-6 md:pl-12 pr-4 sm:pr-6 md:pr-12 pb-4 scroll-pl-4 sm:scroll-pl-6 md:scroll-pl-12 [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden" style={{
        WebkitOverflowScrolling: "touch"
      }}>{archivalCarouselEvents.map(_temp)}</div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => scrollByCards(-1);
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = !canScrollLeft;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <ChevronLeft size={22} />;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t8) {
    t10 = <button type="button" onClick={t7} disabled={t8} aria-label="Scroll left" className="w-11 h-11 rounded-full border border-[#0F1C2E]/20 flex items-center justify-center text-[#0F1C2E] hover:border-[#DF6D2A] hover:text-[#DF6D2A] disabled:opacity-30 disabled:pointer-events-none transition-colors">{t9}</button>;
    $[9] = t8;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <span className="font-body text-[10px] tracking-[0.2em] uppercase text-[#4C596B] hidden sm:inline">Swipe or use arrows to explore</span>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => scrollByCards(1);
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const t13 = !canScrollRight;
  let t14;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <ChevronRight size={22} />;
    $[13] = t14;
  } else {
    t14 = $[13];
  }
  let t15;
  if ($[14] !== t13) {
    t15 = <button type="button" onClick={t12} disabled={t13} aria-label="Scroll right" className="w-11 h-11 rounded-full border border-[#0F1C2E]/20 flex items-center justify-center text-[#0F1C2E] hover:border-[#DF6D2A] hover:text-[#DF6D2A] disabled:opacity-30 disabled:pointer-events-none transition-colors">{t14}</button>;
    $[14] = t13;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  if ($[16] !== t10 || $[17] !== t15) {
    t16 = <section className="bg-[#EBE5D9] py-16 sm:py-24 md:py-32 overflow-hidden border-t border-[#0F1C2E]/10">{t5}{t6}<div className="max-w-[1400px] mx-auto px-4 sm:px-6 md:px-12 mt-8 sm:mt-10 flex items-center justify-center gap-4">{t10}{t11}{t15}</div></section>;
    $[16] = t10;
    $[17] = t15;
    $[18] = t16;
  } else {
    t16 = $[18];
  }
  return t16;
};
export default PastEvents;
function _temp(event) {
  return <Link key={event.slug} href={`/events/${event.slug}`} className="shrink-0 w-[min(88vw,340px)] snap-start group"><article className="h-full flex flex-col bg-[#F4EFE6] border border-[#0F1C2E]/10 hover:border-[#DF6D2A]/40 transition-colors duration-300 overflow-hidden"><div className="w-full aspect-[4/3] overflow-hidden bg-[#0F1C2E]"><EventCardMedia event={event} /></div><div className="flex flex-col flex-1 p-4 sm:p-5"><span className="font-body text-[9px] tracking-[0.2em] uppercase text-[#DF6D2A] mb-2">{event.category}</span><h3 className="font-display text-[20px] sm:text-[22px] text-[#0F1C2E] leading-tight mb-2 group-hover:text-[#DF6D2A] transition-colors line-clamp-2">{event.title}</h3><p className="font-body text-[12px] sm:text-[13px] text-[#4C596B] leading-[1.65] line-clamp-3 mb-4 flex-1">{event.summary}</p><div className="flex flex-col gap-1.5 pt-3 border-t border-[#0F1C2E]/10"><span className="font-body text-[11px] text-[#0F1C2E]/70 flex items-center gap-2"><Calendar size={12} className="text-[#C9A84C] shrink-0" />{event.date}</span><span className="font-body text-[11px] text-[#0F1C2E]/70 flex items-center gap-2"><MapPin size={12} className="text-[#C9A84C] shrink-0" />{event.location}</span></div></div></article></Link>;
}